/* eslint-disable jsx-a11y/anchor-is-valid */
import { FunctionComponent } from 'react';
import languages from '../Data/languages';
import SurveyType, { SurveyTypeValue } from '../Data/SurveyType';
import { parseHtml } from './Helper';
import { FooterContent } from '../components/FooterContent';
import type { Respondent, Template } from '../types';

interface FooterProps {
  template: Template;
  respondent: Respondent;
  surveyType: SurveyTypeValue;
}

export const Footer: FunctionComponent<FooterProps> = ({ template, respondent, surveyType }) => {
  const language = template.language.name;
  const organizationName =
    template.sentByText || respondent.organizationName || respondent.companyName;

  return (
    <>
      <div style={{ height: '1rem' }} />
      <div className="info-text">
        <FooterContent htmlString={template.footerContent} />
        &nbsp;
        <span>
          {organizationName ? (
            <>
              {parseHtml(languages.RUN_BY[language])}&nbsp;
              <span>{organizationName}.</span>
            </>
          ) : (
            <>{parseHtml(languages.RUN_BY_COMPANY[language])}.</>
          )}
        </span>
        {surveyType !== SurveyType.UNIVERSAL && template.enableUnsubscribe && (
          <>
            &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const url = new URL(globalThis.location.href);
                url.searchParams.set('unsubscribe', 'true');
                globalThis.location.href = url.toString();
              }}
              style={{ color: '#b5b5b5' }}
            >
              <span>{languages.UNSUBSCRIBE[language]}</span>
            </a>
          </>
        )}
      </div>
    </>
  );
};
